export default __webpack_public_path__ + "static/media/logo_2022_11.4967a992.png";